import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    /**
     * @param {string} contactNumber
     */
     checkDuplicate: function (contactNumber) {
        const token = Account.getToken();
        const params = {
            mobile_no: contactNumber,
            device_app_id: ConfigManager.getAppId(),
        };

        const url = ConfigManager.getApiModuleUrl() + "/main/CheckDuplicate";

        return BzbsApi.connectBzbsGet(url, token, params).pipe(map(res => res.data));
    },
    /**
     * @param {String} contactNumber (required)
     * @param {String|Null} uuid (optional)
     */
     requestOtp: function(contactNumber, uuid) {
        const token = Account.getToken();
        const params = {
            contact_number: contactNumber,
            app_id: ConfigManager.getAppId(),
            uuid: uuid,
            device_app_id: ConfigManager.getAppId(),
        };

        const url = ConfigManager.getApiUrl() + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map(res => res.data));
    },
    /**
     * @param {string} params
     */
     UpdateNumber: function (params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + "/profile/me/contactnumber";

        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => {
            return res.data
        }));
    },
}